// Track A intent ownership: the single source of truth for whether the
// candidate is in an explicit selected exact-job journey. Track D and Track F
// consume the resulting job id; neither may independently decide intent from
// raw session state.
export const CHECK_FIT_JOB_KEY = 'jobmatchpro:selected-stored-job-id';
export const CHECK_FIT_JOB_SNAPSHOT_KEY = 'jobmatchpro:selected-stored-job-snapshot';

// A stale selected-job id left in sessionStorage from a prior explicit
// check-fit visit must never turn an ordinary /find-jobs visit into an
// exact-job flow. Only an explicit job_id in the URL, or the explicit
// check-fit route reading its own prior session value, may activate intent.
export function readSelectedStoredJobId() {
  if (typeof window === 'undefined') return '';
  const fromUrl = new URLSearchParams(window.location.search).get('job_id') || '';
  if (fromUrl) return fromUrl;
  // Career Profile's explicit "review my Master CV" intent is incompatible
  // with exact-job intent. A stale session job id left over from an
  // abandoned check-fit visit must not hijack this navigation.
  if (isCareerProfileResumeRoute()) return '';
  const isExplicitCheckMyFitRoute = /\/find-jobs\/check-fit\/?$/.test(window.location.pathname || '');
  if (!isExplicitCheckMyFitRoute) return '';
  try { return window.sessionStorage.getItem(CHECK_FIT_JOB_KEY) || ''; } catch (_) { return ''; }
}

export function clearSelectedStoredJobState() {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(CHECK_FIT_JOB_KEY);
    window.sessionStorage.removeItem(CHECK_FIT_JOB_SNAPSHOT_KEY);
  } catch (_) {
    return;
  }
}

// Career Profile links to the explicit check-fit route with this marker to
// review an existing Master CV directly. Distinct from exact-job intent: a
// confirmed candidate must reach their existing submission here instead of
// being bounced back to /dashboard by the generic returning-candidate check.
export function isCareerProfileResumeRoute() {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('open') === 'master-cv';
}
